import {createReducer} from '@reduxjs/toolkit';

import {
    getDashboardsConfigurationRequest,
    getDashboardsConfigurationSuccess,
    getDashboardsConfigurationFail,
    setDashboardsDateStart,
    setDashboardsDateEnd,
} from './actions';


const initialState = {
    conf: undefined,
    loading: false,
};

const dashboardsConfigurationReducer = createReducer(initialState, {
    [getDashboardsConfigurationRequest.type]: (state) => {
        state.loading = true;
    },
    [getDashboardsConfigurationSuccess.type]: (state, action) => {
        return {
            ...state,
            conf: {...action.payload.configuration},
            loading: false,
        };
    },
    [getDashboardsConfigurationFail.type]: (state) => {
        state.loading = false;
    },
    [setDashboardsDateStart.type]: (state, action) => {
        return {...state, ...action.payload};
    },
    [setDashboardsDateEnd.type]: (state, action) => {
        return {...state, ...action.payload};
    },
});

export default dashboardsConfigurationReducer;
